/**
 * Factoid category values for the uvilo-ai app.
 *
 * Frozen literals used by vocabulary seeding. Append new values via
 * `registerVocabularyEntry` / `registerVocabularyValues` — do not invent literals at call sites.
 */
export const UVILO_FACTOID_CATEGORY_VALUES = [
  'identity',
  'perception',
  'relationships',
  'education',
  'skills',
  'work',
  'projects',
  'interests',
  'coaching',
  'preferences',
  'values',
  'media',
  'milestones',
  'habits',
  'events',
  'goals',
  'plans',
  'worries',
] as const;

export type UviloFactoidCategory = (typeof UVILO_FACTOID_CATEGORY_VALUES)[number];
